import "./Flex.css";
import React from "react";

type Props = {
    children: JSX.Element[];
    cols: number;
    alignBottom?: boolean;
    className?: string;
};

const Flex: React.FC<Props> = props => {
    const children = props.children;

    return (
        <div className={`Flex Flex--${props.cols}Col ${props.alignBottom ? "Flex--alignBottom" : ""} ${props.className ?? ""}`}>
            {React.Children.map(children, (child, index) => (
                <div className={`Flex-col Flex-col${index+1}`}>{child}</div>
            ))}
        </div>
    );
};

export default Flex;
